import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { commonLabelConstants } from 'src/app/constants/LabelMessages';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {

  constructor(public activeModal:NgbActiveModal){}
  commonConstant : any;

  @Input() titleContent: any; // Declare an input property to receive data from parent component
  @Input() title:any;
  @Input() heading:any;
  @Input() date:any;

  ngOnInit() {
    this.commonConstant = commonLabelConstants;
  }
}